// Mega Menu JS
if($(window).width() <= 768){
  $(document).on('click','.c2-custom-menu-link:not(.no-links)',function(){
      var attr = this.getAttribute("data-menu");
      $(this).parents('.c2-custom-menu-container').next().show();
      $(this).parents('.c2-custom-menu-container').next().children('.c2-custom-menu-data').hide();
      $(this).parents('.c2-custom-menu-container').next().children('.c2-custom-menu-data[data-menu="'+attr+'"]').css("display","flex");
      $(this).parents('.c2-custom-menu-container').next().next().show();
    });
  $(document).on("click", ".mobile-menu__list-item:not(.has--mega__menu) .submenu__label",function(){
    var input_label = $(this).attr("for");
    var query_input = "#"+input_label;
    var $inputCheckbox = $(query_input);
    $inputCheckbox.prop('checked', !$inputCheckbox.prop('checked'));
  });
}
else{
  
    $(document).ready(function() {
      // When the mouse enters the container or its child elements
      $('.c2-custom-menu-link:not(.no-links)').on('mouseenter', function() {
        $(this).parents(".has-mega-menu").addClass("active_mega");
        $(this).addClass('hovered');
        
      });
      

    $(document).on('mouseover','.c2-custom-menu-link:not(.no-links)',function(e){
        //console.log(this.closest(".navbar-item"),e.target)
        $(this).parents(".has-mega-menu").addClass("active_mega");
        $(this).addClass('hovered');
        //console.log("i work")
        document.querySelector('.c2-custom-menu-link-active').classList.remove('c2-custom-menu-link-active');
        this.classList.add('c2-custom-menu-link-active');
        var current_selected=this.dataset.menu;
        document.querySelector('.c2-custom-menu-data-show').classList.remove('c2-custom-menu-data-show');
        document.querySelector('.c2-custom-menu-data[data-menu="'+current_selected+'"]').classList.add('c2-custom-menu-data-show');
    });
    // When the mouse is outside of the container
      $(document).on('mouseout', function(e) {
        if ($(e.target).closest('.has-mega-menu').length === 0) {
          $(".has-mega-menu.active_mega").removeClass("active_mega")
          //console.log("Mouse is not on custom Links")
        }
      });
    });

}
  
$(document).on("click",".c2-custom-menu-title-box button",function() {
    $(this).parents('.c2-custom-menu-data-container').hide();
    $(this).parents('.c2-custom-menu-data-container').next().hide();
});


$(document).on("change","#blog_sort_by",function() {
  var append_url = $(this).val();
  window.location.href = append_url;
});


  
$(document).on("click",".cs-custom-pagination-list-item",function() {
  $('.cs-custom-pagination-list-item').removeClass('active');
  $(this).addClass('active');
  var pageno=parseInt($(this).text());
  var current_element=(pageno*total_element_in_page)-total_element_in_page;
  $('.custom-main-vedio-sec').addClass('custom-main-vedio-sec-none');
  for(j=current_element;j<current_element+total_element_in_page;j++){
     $( $('.custom-main-vedio-sec')[j]).removeClass('custom-main-vedio-sec-none');
  }

  if($('.cs-custom-pagination-list-item.active').next().length == 0){
    $('.cs-custom-pagination-next').hide();
  }else{
    $('.cs-custom-pagination-next').show();
  }
  if($('.cs-custom-pagination-list-item.active').prev().length == 0){
    $('.cs-custom-pagination-pre').hide();
  }else{
    $('.cs-custom-pagination-pre').show();
  }
});


$(document).on("click",".cs-custom-pagination-next",function() {
  if($('.cs-custom-pagination-list-item.active').next().length > 0) {
    $('.cs-custom-pagination-list-item.active').next().click();
  }
});

$(document).on("click",".cs-custom-pagination-pre",function() {
  if($('.cs-custom-pagination-list-item.active').prev().length > 0) {
    $('.cs-custom-pagination-list-item.active').prev().click();
  }
});


$(document).on("change","#videos_sort_by",function() {
  var append_url1 = $(this).val();
  window.location.href = append_url1;
});

$(document).on("click",".placeholder-img-btn",function() {
  $(this).hide();
  $(this).prev().prev().hide();
  $(this).prev().prev().prev().show();
});

$(document).on("change","#videos_filter_by",function() {
  var show_all_tag_selector = $(this).val();
  if(show_all_tag_selector == 'all_tag'){
    $('.custom-main-vedio-sec').css("display","");
  }else{
    $('.custom-main-vedio-sec').hide();
    // $('.custom-main-vedio-sec[data-tag="'+show_all_tag_selector+'"]').show();
    for (let i = 0; i < $('.custom-main-vedio-sec[data-tag="'+show_all_tag_selector+'"]').length; i++) {
      if(i > total_element_in_page-1){
        $('.custom-main-vedio-sec[data-tag="'+show_all_tag_selector+'"].custom-main-vedio-sec-none').css("display","")
      }else{
        $($('.custom-main-vedio-sec[data-tag="'+show_all_tag_selector+'"]')[i]).show();
      }
    }
  }
});

$( document ).ready(function() {
  $('.custom-faq-related-content[data-heading-name!="category_1"]').hide();
  $($('[data-heading-name="category_1"]')[1]).addClass('c2-custom-border-top');
  $($('[data-heading-name="category_1"]')[$('[data-heading-name="category_1"]').length-1]).addClass('c2-custom-border-bottom');
});
  
$(document).on("click",".custom-faq-related-heading-content",function() {
  $('.custom-faq-related-heading-content.active').removeClass('active');
  $(this).addClass('active');
  var faq_type=$(this).data('heading-name');
  $('.custom-faq-related-content').hide();
  $('.custom-faq-related-content[data-heading-name="'+faq_type+'"]').show();
  $('.custom-faq-related-content').removeClass('c2-custom-border-top');
  $('.custom-faq-related-content').removeClass('c2-custom-border-bottom');
  $($('[data-heading-name="'+faq_type+'"]')[1]).addClass('c2-custom-border-top');
  $($('[data-heading-name="'+faq_type+'"]')[$('[data-heading-name="'+faq_type+'"]').length-1]).addClass('c2-custom-border-bottom');
  $('.custom-faq-content1 h3').text($(this).text().trim());
  
});

$(document).on('click', '.custom-faq-related-content', function(){
    // $(this).siblings().removeClass('active');
})

$(document).on("click",".custom-faq-related-content",function() {
  if($(this).hasClass('active')){
  	$(this).removeClass('active');
  }else{
	$(this).addClass('active');
  }
});

$(document).on("change",".c2_featured_collection-selector",function() {
  var variant = $(this).val();
  $(this).parent().parent().find('.variant-selection').attr('variant',variant);
});

$(document).on("click",".js-recover-password",function() {
  $('.account__title').text('RECOVER PASSWORD');
  $('.heading-form #customer_register_link').text('SIGN UP');
});

$(document).on("click",".cancel-recover-password",function() {
  $('.account__title').text('LOGIN');
  $('.heading-form #customer_register_link').text('CREATE ACCOUNT');
});

$(document).on("click",".c2-rocommendations-product-add-to-cart",function() {
  $.ajax({
  type: 'POST',
  url: '/cart/add.js',
  data: {
    quantity: 1,
    id: $(this).data('id')
  },
    dataType: 'json', 
   success: function (data) { 
    Shopify.theme.jsAjaxCart.updateView();
   } 
   });
});


$(document).on("click",".filter-btn",function() {
  $('.c2-slider-faceted-filter-form').addClass("c2-slider-filter-form-active");
  $('body').addClass("c2-slider-filter-opened");
  $('.fillter-overlay').addClass("fillter-overlay-active");
});

$(document).on("click",".faceted_filtering_heading .icon",function() {
  $('.c2-slider-faceted-filter-form').removeClass("c2-slider-filter-form-active");
  $('body').addClass("c2-slider-filter-opened");
  $('.fillter-overlay').removeClass("fillter-overlay-active");
});

$(document).on("click",".fillter-overlay-active",function() {
  $('.c2-slider-faceted-filter-form').removeClass("c2-slider-filter-form-active");
  $('body').addClass("c2-slider-filter-opened");
  $('.fillter-overlay').removeClass("fillter-overlay-active");
});

$(document).on("click",".frequently-add-to-cart",function() {
  var frequently_product = $(this).next().find('.frequently-id').val();

  $.ajax({
  type: 'POST',
  url: '/cart/add.js',
  data: {
    quantity: 1,
    id: frequently_product
  },
   dataType: 'json', 
   success: function (data) { 
    Shopify.theme.jsAjaxCart.updateView();
    Shopify.theme.jsAjaxCart.showDrawer();
   } 
 });
});
$(document).on("click",'.pdp-custom-faq-main-container .custom-faq-related-content',function() {
  if(window.outerWidth>1024){
     var data_image_url =  $(this).data('image-url');
      if(data_image_url!='#'){
        $('.pdp-custom-faq-main-container .custom-faq-image-container .custom-faq-image').hide();
        $('.pdp-custom-faq-main-container .custom-faq-image-container .custom-faq-image[data-image-url="'+data_image_url+'"]').show();    
      }
  }
});


$(document).on("click",'.block-product-order',function() {
  $.ajax({
  type: 'POST',
  url: '/cart/add.js',
  data: {
    quantity: 1,
    id: $(this).data('id')
  },
    dataType: 'json', 
   success: function (data) { 
    window.location.href='/cart/checkout';
   }
 });
});

if($(window).width() <= 768){
  setTimeout(function() { 
    $('.block-col-with-color-row').flickity({
      cellAlign: 'left',
      contain: true,
      draggable: true,
      freeScroll: true,
      prevNextButtons: false,
    });
  }, 1000);
  
}


$(document).on("click",".Custom-login-foam .button.button--primary",function() {
  $('.Custom-login-foam .button[type=submit]').click();
});

$(document).on("click",".register_form .button",function() {
  $('.register_form .button[type=submit]').click();
});
$.fn.totalHeight = function(includeMargin = false) {
  let totalHeight = 0;
  totalHeight += $(this).outerHeight(includeMargin);
  $(this).children().each(function() {
      totalHeight += $(this).outerHeight(includeMargin);
  });

  return totalHeight;
}
$(document).on("click",".filter-submit-button-container .button--primary.custom-2",function() {
  event.preventDefault();
 $('.filter-submit-button-container .button--primary.custom-1').trigger("click"); 
});

$(document).on("click",".mobile-menu-link",function(e) {
  e.stopPropagation();
  const $content_header = $('.custom-header .mobile-menu__content');
  const $login_footer = $(".c2-mobile-login");
  const $parentElement = $(this).closest(".mobile-menu__list-item");
  const footer_height = $login_footer.innerHeight();
  const $inputBox = $parentElement.find('.submenu__input[type="checkbox"]')[0];
  if(!$inputBox.checked){
    $inputBox.checked = true; 
    if(!$content_header.hasClass("has-active_menu")){
      $content_header.addClass("has-active_menu");
    }
    //let contentHeight = $content_header.totalHeight(false);
    $content_header.css('padding-bottom',$login_footer.innerHeight()+30);
    $content_header.css('margin-bottom',$login_footer.innerHeight()+30);
    //$content_header.css('height',`calc(100vh - ${footer_height}px)`);   
    // Fallback code in case ever needed. 
  }else {
    $inputBox.checked = false;
  }
  const $allinputBoxes = $content_header.find('.submenu__input[type="checkbox"]:checked');
  if(!($allinputBoxes.length > 0)){
     $content_header.removeClass("has-active_menu");
     $content_header.css('margin-bottom',0);
     $content_header.css("padding-bottom",0);
  } 
  
});


// onclick down-page
$(document).on("click",".go-footer-btn",function() {
  $('body').css('height','unset');
  $('footer')[0].scrollIntoView({ block: 'start',  behavior: 'smooth' });
  $('.up-down-btn').removeClass('go-footer-btn');
  $('.up-down-btn').addClass('go-header-btn');
});

// onclick up-page

$(document).on("click",".go-header-btn",function() {
  $('body').css('height','unset');
  $('.top-bar')[0].scrollIntoView({ block: 'start',  behavior: 'smooth' });
  $('.up-down-btn').addClass('go-footer-btn');
  $('.up-down-btn').removeClass('go-header-btn');
});

const footer = document.querySelector('.footer');
let isFooterVisible = false;
let timeoutId = null;

// Update the arrow positions on scroll
window.addEventListener('scroll', updateArrowPositions);

function updateArrowPositions() {
   if($(window).scrollTop()>100){
      $('.scroll--top-btn').addClass('active');  
  }
  else{
      $('.scroll--top-btn').removeClass('active');  
  }
  clearTimeout(timeoutId);
  timeoutId = setTimeout(() => {
    const footerRect = footer.getBoundingClientRect();
    const newIsFooterVisible = footerRect.top < window.innerHeight && footerRect.bottom >= 0;
  
    if (newIsFooterVisible !== isFooterVisible) {
      isFooterVisible = newIsFooterVisible;
      toggleFooterClass();
    }
  }, 20); // Adjust the delay as needed
}

function toggleFooterClass() {
  if (isFooterVisible) {
    $('.up-down-btn').removeClass('go-footer-btn');
  $('.up-down-btn').addClass('go-header-btn');
  } else {
     $('.up-down-btn').addClass('go-footer-btn');
  $('.up-down-btn').removeClass('go-header-btn');
  }
}


function isIOSDevice() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

if (isIOSDevice()) {
  $(".c2-custom-menu-data-container").addClass("ios_class");
}

// $(document).on("click",".swatch__option",function() {
//   var title = $(this).parents('.product__information').find('.title').text().trim();
//   var val = $(this).find('input').val();
//   $('.product-gallery__image').show();
//   if($('.product-gallery__image img:not([alt*="'+val+'"])').length>0){
//     $('.product-gallery__image img:not([alt*="'+val+'"])').parents('.product-gallery__image ').hide();
//     $('.product-gallery__image img[alt="'+title+'"]').parents('.product-gallery__image ').show();
//   }
// });

// blog read more hover
let all_read_more_btns = document.querySelectorAll('.blog-card__read-more');
if(all_read_more_btns.length > 0){
  all_read_more_btns.forEach((btn)=>{
    const btnLink = btn.querySelector('a');
    if (btnLink) {
      btnLink.addEventListener('mouseover', ()=> {
        btn.querySelector('svg path').style.fill = "#000";
      })

      btnLink.addEventListener('mouseleave', ()=> {
        btn.querySelector('svg path').style.fill = "#ff671d";
      })
    }

  })
}

// Resolving mobile menu not opening issue

if(window.location.toString().includes("dealer-locator")){
  // debugger;
  //console.log("dealer");
  const mobileToggle = document.querySelector('.mobile-menu__toggle-button');
  if (mobileToggle) {
    mobileToggle.addEventListener('click', (e)=> {

      let current_attribute = document.querySelector('.mobile-menu__toggle-button').getAttribute('data-show-mobile-menu');

      setTimeout(()=>{
        if(current_attribute == "false"){
          document.querySelector('.mobile-menu__toggle-button').setAttribute('data-show-mobile-menu', "true");
          document.querySelector('.mobile-menu__toggle-icon').classList.toggle('is-active');
        }
        else{
          setTimeout(()=> {
            document.querySelector('body').classList.remove('mobile-menu--opened');
          }, 50)
          document.querySelector('.mobile-menu__toggle-button').setAttribute('data-show-mobile-menu', "false");
          document.querySelector('.mobile-menu__toggle-icon').classList.toggle('is-active');
        }
      })

    })
  }
}
// Usage
if (isIOSDevice()) {
  $(".c2-mobile-login").addClass("margin-top_minus")
} else {
   //console.log('This is not an iOS device.');
}
// Bundle Product Swatch Fix
let bundle_product_swatch = document.querySelectorAll('.bundle-product-title-select');

if(bundle_product_swatch.length > 0){
  for(let i=0; i<bundle_product_swatch.length; i++){
    bundle_product_swatch[i].addEventListener('change', ()=> {
    let selected_option_value = bundle_product_swatch[i].options[bundle_product_swatch[i].selectedIndex].value;
    bundle_product_swatch[i].closest('.bundle-product-title').querySelector('.bundle-variant-id').value = selected_option_value;
  })
  }
}


$(document).ready(function(){
    function scrollToElm(container, elm, duration){
      var targetOffset = $(elm).offset().top;
        // Scroll to the target element
        $("html, body").animate({
          scrollTop: targetOffset - 90
        }, 1000); // Adjust the duration as needed
      
        // var pos = getRelativePos(elm);
        // scrollTo(container, pos.top , duration/1000);  // duration in seconds
      }
      
      // function getRelativePos(elm){
      //   var pPos = elm.parentNode.getBoundingClientRect(), // parent pos
      //       cPos = elm.getBoundingClientRect(), // target pos
      //       pos = {};
      
      //   pos.top    = cPos.top    - pPos.top + elm.parentNode.scrollTop,
      //   pos.right  = cPos.right  - pPos.right,
      //   pos.bottom = cPos.bottom - pPos.bottom,
      //   pos.left   = cPos.left   - pPos.left;
      
      //   return pos;
      // }
          
      // function scrollTo(element, to, duration, onDone) {
      //     var start = element.scrollTop,
      //         change = to - start,
      //         startTime = performance.now(),
      //         val, now, elapsed, t;
      
      //     function animateScroll(){
      //         now = performance.now();
      //         elapsed = (now - startTime)/1000;
      //         t = (elapsed/duration);
      
      //         element.scrollTop = start + change * easeInOutQuad(t);
      
      //         if( t < 1 )
      //             window.requestAnimationFrame(animateScroll);
      //         else
      //             onDone && onDone();
      //     };
      
      //     animateScroll();
      // }
      
      // function easeInOutQuad(t){ return t<.5 ? 2*t*t : -1+(4-2*t)*t };

    $(document).on("click", ".shipping_restrict_filter_dropdown ul li", function(){
      var container_name = $(this).attr('data-container-name');
      $(this).closest(".shipping_restrict_filter_dropdown").find('.restrict__dropdown .restrict_dropdown_text').html(container_name);
      $(this).closest(".shipping_restrict_filter_dropdown").find('.restrict__search').val(container_name);
      $(this).closest(".shipping_restrict_filter_dropdown").removeClass('active');
      $(this).closest(".shipping_restrict_filter_dropdown").find('.restrict__dropdown').click();
      $(this).closest(".shipping_restrict_filter").find('.shipping_restrict_filter_data .custom-faq-related-content-container .custom-faq-related-content').removeClass('active')
      var filter__container = $(this).closest(".shipping_restrict_filter").find('.shipping_restrict_filter_data .custom-faq-related-content-container .custom-faq-related-content[data-container-name="'+container_name+'"]');
      
      // var outer_container = $(this).closest(".shipping_restrict_filter").find('.shipping_restrict_filter_data .custom-faq-related-content-container');
      var outer_container = $(this).closest("html");
      if(filter__container){
        scrollToElm( outer_container[0], filter__container[0], 600 );  
        $(filter__container).addClass('active');
      }
    });

   $(document).on("click", ".shipping_restrict_filters_container .restrict__dropdown", function(){
     if($(this).hasClass('active')){
       $(this).removeClass('active');
       $(this).closest('.shipping_restrict_filter_dropdown').find('ul').slideUp();
     }
     else{
       $(this).addClass('active');
       $(this).closest('.shipping_restrict_filter_dropdown').find('ul').slideDown();
       
     }
   });

})





// reCaptcha
// let page_url = window.location.href;
// if(page_url.includes('/pages/dealer-sales-inquiries')){
//   let dealer_form = document.querySelector('#form-dealer');
//   dealer_form.addEventListener('submit', function(e){
//     e.preventDefault();
//     let captcha_response = grecaptcha.getResponse();
//     if (captcha_response.length === 0) {
//       document.querySelector('.re-captcha-error').classList.add('active');

//       setTimeout(()=>{
//         document.querySelector('.re-captcha-error').classList.remove('active');
//       },4000)
//     }
//     else{
//       this.submit();
//     }
//   })
// }


document.addEventListener('DOMContentLoaded', function () {

    /* --------------------------------------------------------------
       1. TRANSPOSE THE ORIGINAL TABLE (your original code)
       -------------------------------------------------------------- */
    function transformComparisonTable() {
        const oldTbody = document.querySelector('.new-comparison-section .comparison_table tbody');
        const newInner   = document.querySelector('.new_comparison__table_container .new_comparison__table_inner');
        if (!oldTbody || !newInner) return;

        const rows       = oldTbody.querySelectorAll('tr');
        const firstThs   = rows[0] ? rows[0].querySelectorAll('th') : [];
        const colCount   = firstThs.length;

        // clear previous transposed rows
        newInner.innerHTML = '';

        for (let i = 0; i < colCount; i++) {
            const tr = document.createElement('tr');
            tr.className = 'new_table_block';

            rows.forEach(row => {
                const cells = row.querySelectorAll('th, td');
                if (cells[i]) tr.appendChild(cells[i].cloneNode(true));
            });

            newInner.appendChild(tr);
        }

        // remove the original table (keeps the DOM clean)
        const oldTable = document.querySelector('.new-comparison-section table.comparison_table');
        if (oldTable) oldTable.remove();
    }

    /* --------------------------------------------------------------
       2. EQUALISE HEIGHTS **PER SPEC COLUMN** (skip product image)
       -------------------------------------------------------------- */
    function equaliseColumnHeights() {
        const container = document.querySelector('.new_comparison__table_inner');
        if (!container) return;

        const rows = container.querySelectorAll('tr.new_table_block');
        if (!rows.length) return;

        const colCount = rows[0].querySelectorAll('td, th').length;

        // start from column 1 → skip the first column (product image / heading)
        for (let col = 1; col < colCount; col++) {
            let max = 0;
            const cells = [];

            rows.forEach(row => {
                const cell = row.querySelectorAll('td, th')[col];
                if (!cell) return;

                // reset
                cell.style.height = 'auto';
                void cell.offsetHeight;          // force reflow
                const h = cell.offsetHeight;
                if (h > max) max = h;
                cells.push(cell);
            });

            // apply
            cells.forEach(c => c.style.height = max + 'px');
        }
    }

    /* --------------------------------------------------------------
       3. RUN BOTH – TRANSPOSE FIRST, THEN EQUALISE
       -------------------------------------------------------------- */
    function runAll() {
        transformComparisonTable();
        // give the browser a tick to paint the new rows
        requestAnimationFrame(() => {
            setTimeout(equaliseColumnHeights, 50);
        });
    }

    // ---- first run ----
    runAll();

    // ---- after images / Yotpo reviews load ----
    window.addEventListener('load', () => setTimeout(equaliseColumnHeights, 300));

    // ---- on resize (mobile rotate, etc.) ----
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(equaliseColumnHeights, 200);
    });

    // ---- if anything injects content later (Yotpo, etc.) ----
    const observer = new MutationObserver(() => setTimeout(equaliseColumnHeights, 300));
    observer.observe(document.querySelector('.new_comparison__table_inner') || document.body, {
        childList: true,
        subtree: true
    });
});

document.querySelectorAll('.js-smooth-scroll').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);

        if (targetElement) {
            // Calculate position: Element ki doori - 100px offset
            const offset = 100;
            const elementPosition = targetElement.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    });
});
          
      

